import React from "react";
import moment from "moment";
import { NotifiactionBell } from "../../../../assets/common-svg/CommonSvg";

const MentionNotification = ({ mention, handleMention }) => {
    return ( <>
        <div
            onClick={() => handleMention(mention)}
            className="overflow-auto scroll-smooth bg-white pb-3 pt-3 cursor-pointer"
        >
            <div className="flex gap-3 items-start cursor-pointer">
                <span className="align-self-center">
                    <NotifiactionBell />
                </span>
                <div className="flex flex-col gap-1 items-start">
                    <p className="text-sm text-gray-500">
                        <span className="font-medium text-blue-600">
                            {mention.sender_name}
                        </span>{" "}
                        mentioned you in
                        <span className="font-semibold text-gray-700 ml-1">
                            {mention.chat_room_name}
                        </span>
                    </p>
                    <p className="text-base text-gray-800 whitespace-pre-wrap">{mention.message}</p>
                    <p className="text-xs text-gray-400 whitespace-nowrap">
                        {moment(mention.created_at).fromNow()}
                    </p>
                </div>
            </div>
        </div>
      <hr className="mt-2" />
  </>  );
};

export default MentionNotification;
